import { render, staticRenderFns } from "./combo-card-shop-edit.vue?vue&type=template&id=40d40bd0&scoped=true"
import script from "./combo-card-shop-edit.vue?vue&type=script&lang=js"
export * from "./combo-card-shop-edit.vue?vue&type=script&lang=js"
import style0 from "./combo-card-shop-edit.vue?vue&type=style&index=0&id=40d40bd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d40bd0",
  null
  
)

export default component.exports